import * as React from "react"

import {Text} from "../text/text"

import imgDesigner from '../../images/designer/design01.jpg'


import './designer.scss';

// Defining the <Greeting> component
export const Designer = (props) => {
  return (
    <div className="design">
      <div className="desing__imgCont">
      <div className="design__imgs">
        <div className="design__img"> <source media="(min-width:650px)" srcSet={imgDesigner}></source>
          <source media="(min-width:255px)" srcSet={imgDesigner}></source>
          <img className="design__imgSrc" src={imgDesigner} alt="imgDesigner screen"/>
          </div>
      </div>
      </div>
      

      <Text page={'designer'}></Text>
    </div>
        
    )
  }